export function invalidFieldFound(conditionIndex, category, subCondition) {
    return {
        type: ACTION_INVALID_FIELD_FOUND,
        conditionIndex,
        category,
        subCondition,
    };
}
export const ACTION_INVALID_FIELD_FOUND = 'QRY_ACTION_INVALID_FIELD_FOUND';


export function removeInvalidField(category, field) {
    return {
        type: ACTION_REMOVE_INVALID_FIELD,
        category,
        field,
    };
}
export const ACTION_REMOVE_INVALID_FIELD = 'QRY_ACTION_REMOVE_INVALID_FIELD';


export function replaceInvalidField(category, oldField, newField, invalidFields) {
    return {
        type: ACTION_REPLACE_INVALID_FIELD,
        category,
        field: oldField,
        newField,
        invalidFields,
    };
}
export const ACTION_REPLACE_INVALID_FIELD = 'QRY_ACTION_REPLACE_INVALID_FIELD';
